import React from 'react';

const ProjectReportsPage = () => {
    return (
        <div>
            
        </div>
    );
}

export default ProjectReportsPage;
